import { resizableAspectResizerId } from "constants/portalIds";
import { CHARACTERS_PATH } from "components/Characters/constants/charactersConsts";
import {
  ADDITIONAL_TUTORIAL_DATA_KEYS,
  TUTORIAL_STEP_TYPES,
} from "../consts/tutorialConsts";

export const getResizableSectionTutorialSteps = () => {
  return [
    {
      type: TUTORIAL_STEP_TYPES.TOOLTIP,
      sourceId: resizableAspectResizerId,
      position: "bottom",
      width: 400,
      children: `If you want to resize a section, look out for this gray bar at the bottom of a textarea. Click and drag the bar to resize. If the content is larger than the height, double-click the gray bar to expand to the size of the content.`,
      nextLabel: "GOT IT",
      shouldRender: ({ page, id, additionalData }) =>
        page === CHARACTERS_PATH &&
        id &&
        additionalData[ADDITIONAL_TUTORIAL_DATA_KEYS.RESIZABLE_ASPECT_PRESENT],
    },
  ];
};
